import React from 'react';
import { Link } from 'gatsby';
import { createUseStyles, useTheme } from 'react-jss';
import { PageOuter } from 'components/PageContainers';
import logo from 'images/logo.svg';
import MobileNav from './MobileNav';
import DesktopNav from './DesktopNav';
import SiteBanner from './SiteBanner';
import { ISiteBanner } from 'types';

const useStyles = createUseStyles((theme) => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    // paddingLeft: '1.25rem',
    paddingLeft: '0px !important',
    paddingRight: '0px !important',
    maxWidth: '1280px !important',
    height: '80px',
    ['@media(min-width: 760px)']: {
      padding: '1.25rem 2rem'
    }
  },
  logo: {
    width: '16.2rem',
    marginTop: '.5rem',
    maxWidth: '174px',
    [`@media(min-width: ${theme.breakpoints.large.min})`]: {
      width: '23.1rem'
    }
  },
  login: {
    fontWeight: 'bold',
    color: theme.colors.black
  },
  nav: {
    display: 'none',
    [`@media(min-width: ${theme.breakpoints.medium.min})`]: {
      display: 'block'
    }
  }
}));

interface IProps {
  includeSiteBanner?: boolean;
  siteBanner: ISiteBanner | null;
}

const Header: React.FunctionComponent<IProps> = ({ includeSiteBanner = false, siteBanner }) => {
  const theme = useTheme();
  const styles = useStyles({ theme });

  return (
    <header>
      {includeSiteBanner && <SiteBanner siteBanner={siteBanner} />}
      <PageOuter>
        <div className={styles.header}>
          <Link to="/">
            <img src={logo} className={styles.logo} alt="Edge Impulse logo" />
          </Link>
          <DesktopNav />
        </div>
      </PageOuter>
    </header>
  );
};

export default Header;
